module.exports = __webpack_public_path__ + "images/token-overlay-5f4e1c154e8c0cb842b35e7c5853fd8f.jpg";